__turbopack_context__.v({
  "button": "Pagination-module__Hew-Ea__button",
  "container": "Pagination-module__Hew-Ea__container",
});
